<footer>
    <div class="row">
      <div class="order-2 col-lg-3 col-md-6 col-sm-6 order-lg-1 text-center-m">
        © 2023 PTC All Rights Reserved. <span class="ms-2 text-nowrap">Version 1.4.6</span>
      </div>
      <div class="order-1 col-lg-6 col-md-12 order-lg-2 text-center px-lg-0 mb-4">
        <img class="mr-2" src="../../assets/Images/visa-ico.png" />
        <img class="mr-2" src="../../assets/Images/master-ico.png" />
        <img class="mr-2" src="../../assets/Images/american-ico.png" />
        <img src="../../assets/Images/discover-ico.png" />
        <!-- <img src="../../../assets/Images/cc (1).png" alt=""> -->
        <span id="seal" class="pl-sm-5 pt-4 pt-sm-0 d-sm-inline-block d-block" (click)="onSealClick()">
            <img class="seal-img" src="https://www.rapidscansecure.com/siteseal/Seal.aspx?code=133,814735923C2CE05C4617632A722F9D35A49CA79A"/>
        </span>
      </div>
      <div class="order-3 col-lg-3 col-md-6 col-sm-6 order-lg-3 text-right pl-0 text-center-m footer_links">
        <!-- <a routerLinkActive="list-item-active" routerLink="/contact-us" >Contact Us</a> -->
        <a  href="https://www.pipelinetesting.com/contact-us/?/?" target="_blank">Contact Us</a>
        <!-- <a routerLinkActive="list-item-active"  href="https://www.pipelinetesting.com/contact-us/?/?" >Contact Us</a> -->
        <a routerLinkActive="list-item-active" routerLink="/privacy-policy" class="ms-2">Privacy Policy</a>
        <a routerLinkActive="list-item-active" routerLink="/terms-condition" class="ms-2">Terms & Conditions</a>
      </div>
    </div>
  </footer>

  <script>
    document.addEventListener('DOMContentLoaded', function () {      
        CollectJS.configure({
            "paymentSelector" : "#demoPayButton",
            "variant" : "inline",
            "fields": {
                "ccnumber": {
                    "selector": "#txt-card-no",
                    "title": "Card Number"                 
                },
                "ccexp": {
                    "selector": "#txt-card-exp",
                    "title": "Card Expiration"
                },
                "cvv": {
                    "display": "show",
                    "selector": "#txt-cvv",
                    "title": "CVV Code"                    
                }
            },
            'price': '1190.00',
            'currency':'USD',
            'country': 'US',
            'validationCallback' : function(field, status, message) {              
                if (status) {
                    var message = field + " is now OK: " + message;
                } else {
                    var message = field + " is now Invalid: " + message;
                }
                // console.log(message);
            },
            "timeoutDuration" : 10000,
            "timeoutCallback" : function () {             
                // console.log("The tokenization didn't respond in the expected timeframe.  This could be due to an invalid or incomplete field or poor connectivity");
            },
            "fieldsAvailableCallback" : function () {              
                // console.log("Collect.js loaded the fields onto the form");
            },
            'callback' : function(response) {             
                alert(response.token);
                var input = document.createElement("input");
                input.type = "hidden";
                input.name = "payment_token";
                input.value = response.token;
                var form = document.getElementsByTagName("form")[0];
                form.appendChild(input);
                form.submit();
            }
        });
    });
</script>